import { render, staticRenderFns } from "./QuizContext.vue?vue&type=template&id=630b1422&scoped=true&"
import script from "./QuizContext.vue?vue&type=script&lang=js&"
export * from "./QuizContext.vue?vue&type=script&lang=js&"
import style0 from "./QuizContext.vue?vue&type=style&index=0&id=630b1422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b1422",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardTitle,VImg})
